import { memo } from 'react';

import { BubbleLoadingWrapper, Dot } from './BubbleLoading.styles';

export const BubbleLoading = memo(() => {
  return (
    <BubbleLoadingWrapper>
      <Dot />
      <Dot />
      <Dot />
    </BubbleLoadingWrapper>
  );
});

BubbleLoading.displayName = 'BubbleLoading';
